// Effect 8 — Rising pitch ramp on the letter chain. THE most on-theme piece of juice for a word
// game: each letter plays a semitone higher than the last, so the word becomes a musical phrase and
// a longer word climbs to a higher climax — the do-re-mi ladder from the brief, in sound. Near-zero
// cost. Scheduled through WebAudio so the chain stays tight regardless of frame timing.
import { feel } from "../feel";
import { blip, semitone } from "../audio";
import { registerEffect } from "../registry";
import { intensity, timed } from "../../tuner/scale";

export function registerPitchramp(): void {
  registerEffect(
    { name: "pitchramp", label: "8 · Pitch ramp" },
    "word:valid",
    ({ word }) => {
      const step = timed(feel.pitchramp.noteMs) / 1000;
      const steps = feel.pitchramp.semitones * intensity(feel.pitchramp); // intensity = climb steepness
      [...word].forEach((_, i) => {
        blip({
          freq: semitone(feel.pitchramp.rootFreq, i * steps),
          type: feel.pitchramp.waveform as OscillatorType,
          volume: feel.pitchramp.volume,
          durationMs: feel.pitchramp.noteMs * 1.4,
          when: i * step,
        });
      });
    },
  );
}
